// Booking-time operator policy: which cities we sell in, and each operator's rider-facing
// rules (passenger cap, cancellation window, service hours, terms).
//
// This is the pre-order counterpart to `ticket.operator`. It is a separate public endpoint
// rather than a field on /transit/cities because that route is auth-gated and returns
// nothing when ONDC is switched off — which would blank the terms for a ticket a rider is
// already holding.
import { request } from './http';
import type { OperatorView } from './types';

export interface OperatorPolicyCity {
  code: string;
  name: string;
  modes: string[];
  systemCode?: string;
}

export interface OperatorPolicyResponse {
  version: number;
  cities: OperatorPolicyCity[];
  operators: OperatorView[];
}

/** Nothing known — every screen then falls back to its own generic copy. */
export const NO_POLICY: OperatorPolicyResponse = { version: 0, cities: [], operators: [] };

export const operatorPolicyApi = {
  get: (cityCode?: string) =>
    request<OperatorPolicyResponse>(
      'GET',
      cityCode
        ? `/api/v1/transit/operator-policy?city=${encodeURIComponent(cityCode)}`
        : '/api/v1/transit/operator-policy'
    ),
};
